


















































































import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { Account } from '@/api/generated'
import ContactRespondeco from '@/main/header/contact-respondeco.vue'
import { isRespondeco } from '@/config/environments'

@Component({
  components: { ContactRespondeco },
})
export default class AuthenticatedUserBar extends Vue {
  @Prop({
    type: Object,
  })
  public readonly activeUser!: Account

  @Prop({
    type: Boolean,
  })
  public readonly isAdmin!: boolean

  public isRespondeco: boolean = isRespondeco()

  get isOrganisation(): boolean {
    return this.activeUser.organisation.id !== -1
  }
}
